import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Divider from '@material-ui/core/Divider'

const initialState = {
    input: {
        account: '',
        password: '',
        name: '',
        role_id: 0,
        pf_id: '',
        is_active: true,
    },
    dialogOpen: false,
    roleList: []
}

class AddUserDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'AddUserDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset() {
        const { auth } = this.props
        const roleList = utils.convertSort({ source: this.props.roleList, replaceText: true })
                                .filter(item => {
                                    return auth.isSuperUser || auth.isAdmin || item.id !== item.root_role_id
                                })
        this.setState({
            input: {
                ...initialState.input,
            },
            roleList,
        })
    }

    OpenDialog() {
        this.reset()
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        label={this.t('account')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.account}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    account: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                    <TextField
                        type="password"
                        label={this.t('password')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.password}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    password: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                    <div className={this.props.classes.passwordFormat}>{this.t('passwordFormatError')}</div>
                    <TextField
                        label={this.t('name')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.name}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    name: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                    <FormControl margin="dense" fullWidth>
                        <InputLabel htmlFor="role_id">{this.t('role')}</InputLabel>
                        <Select
                            value={this.state.input.role_id}
                            onChange={(event) =>
                                this.setState({
                                    input: {
                                        ...this.state.input,
                                        role_id: event.target.value,
                                    },
                                })
                            }>
                            <MenuItem value={0}>{this.t('pleaseSelect')}</MenuItem>
                            {this.state.roleList.map((item)=>(
                                <MenuItem value={item.id} key={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl margin="dense" fullWidth>
                        <InputLabel>{this.t('isActive')}</InputLabel>
                        <Select
                            value={this.state.input.is_active}
                            onChange={(event) =>
                                this.setState({
                                    input: {
                                        ...this.state.input,
                                        is_active: event.target.value,
                                    },
                                })
                            }>
                            <MenuItem value={true}>{this.t('enable')}</MenuItem>
                            <MenuItem value={false}>{this.t('disable')}</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (!utils.passwordFormat(this.state.input.password)) {
                                utils.addToast(this.t('passwordFormatError'), 'error')
                                return
                            }
                            utils.apiRequest(
                                'post',
                                API.USER,
                                {
                                    ...this.state.input,
                                    is_active: this.state.input.is_active === true,
                                    role_id: parseInt(this.state.input.role_id),
                                },
                                (_data) => {
                                    this.confirm()
                                }
                            )
                        }}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            height: '300px',
            padding: '0 14px',
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        radioLabel: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
        },
        passwordFormat: {
            fontSize: '12px',
            color: '#69131c',
            paddingBottom: '10px',
        },
    }
}

AddUserDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    roleList: PropTypes.object,
    auth: PropTypes.object,
}

export default hoc(styles)(AddUserDialog)
